<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input [ttRememberId]="'w_custactcalcpickselect.filtervalue/' + p2PoFinishKeyno + '/' + custactNo" ttLabel="custactcalcpickselect_filter" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListPickPackages" [ttFilter]="setting.filtervalue"></tt-list>
</tt-page>
